<template>
  <div v-if="stats">
    <div class="container container-fluid">
      <div class="jumbotron" v-show="!closeJumbotron">
        <span class="top-right" @click="closeJumbo()">&times;</span>
        <p class="lead">
          Detta är en överblicksvy och presenterar information som handlar om FHabian patienter och dess status.
        </p>
      </div>
      <!-- <button class="btn btn-info btn-sm float-right" @click="downloadExcel()">
        <img src="@/assets/img/excel.svg?data" alt="Ikon för Excel" class="img-fluid" /> Hämta ut excelrapport
      </button> -->
      <h1 class="pull-left text-muted">Dashboard<sup class="sup">Kardiolog</sup></h1>
      <div class="clearfix"></div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-3">
              <p><strong>Totalt antal med FH-gendiagnos</strong>: {{ stats.numWithFHGeneticDiagnosis }} st</p>
              <p><strong>Inmatade index</strong>: {{ stats.numIndexPatients }} st</p>
              <p><strong>Nydiagnostiserade</strong>: {{ stats.numNewlyDiagnosed }} st</p>
              <p><strong>Nydiagnostiserade barn</strong>: {{ stats.numNewlyDiagnosedChildren }} st</p>
              <p><strong>Komplett bedömda</strong>: {{ stats.numEvaluated }} st</p>
              <p><strong>Frikända från FH-diagnos</strong>: {{ stats.numDiagnosedHealthy }} st</p>
            </div>
            <div class="col-lg-4">
              <p>
                <strong>Inbjudna</strong>: {{ stats.numInvited }} st
              </p>
              <p>
                <strong>Accepterat inbjudan</strong>: {{ stats.numAccepted }} st
                ({{ stats.percAcceptedInvitation }}%)
              </p>
              <p>
                &nbsp; &nbsp; <strong>Lämnat blodprov</strong>: {{ stats.numPersonsWithBloodSampleResults }} st
                ({{ stats.percPersonsWithBloodSampleResults }}%)
              </p>
              <p>
                &nbsp; &nbsp; <strong>Lämnat gentest</strong>: {{ stats.numPersonsThatHasHadAGeneticTest }} st
                ({{ stats.percPersonsThatHasHadAGeneticTest }}%)
              </p>
              <p>
                <strong>Komplett bedömda</strong>: {{ stats.numEvaluated }} st
                ({{ stats.percEvaluated }}%)
              </p>
              <p>
                &nbsp; &nbsp; <strong>Nydiagnostiserade</strong>: {{ stats.numNewlyDiagnosed }} st
                ({{ stats.percNewlyDiagnosed }}%)
              </p>
              <p>
                &nbsp; &nbsp; <strong>Frikända från FH</strong>: {{ stats.numDiagnosedHealthy }} st
                ({{ stats.percDiagnosedHealthy }}%)
              </p>
              <p>
                <strong>Nydiagnostiserade som överförts som index</strong>: {{ stats.numNewlyDiagnosedWhoHasBeenConvertedToIndexPatients }} st
                ({{ stats.percNewlyDiagnosedWhoHasBeenConvertedToIndexPatients }}%)
              </p>
              <!--
              <div class="well">
                <p><strong>Påminnelser</strong>: {{ mockTotalReminders }} (totalt antal)</p>
                <p><strong>Påminnelser inbjudan - efter 14 dagar</strong>: {{ mockInviteReminder }}</p>
                <p><strong>Påminnelse lämna blodprov - efter 30 dagar</strong>: {{ mockBloodtestReminder }}</p>
                <p><strong>Påminnelse lämna genetiskt test - efter 30 dagar</strong>: {{ mockGentestReminder }}</p>
              </div>
              -->
            </div>
            <div class="col-lg-5">
              <p><strong>Genomsnittlig tid i dagar från accepterat inbjudan till lämnat blodprov</strong>: {{ stats.bloodSampleAvg }}</p>
              <p><strong>Genomsnittlig tid i dagar från accepterat inbjudan till komplett bedömning</strong>: {{ stats.evaluationAvg }}</p>
              <p><strong>Ratio gentestade/blodprovscreenade</strong>: {{ stats.rationGeneticTestsByBloodTest }}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'dashboardcardio',
  components: {
  },
  data () {
    return {
      stats: null,
      excelJson: null,
      closeJumbotron: (localStorage.getItem('jumbotron-closed-dashboard-cardio') === 'true') || false
    }
  },
  methods: {
    async getDashboardStats () {
      let loader = this.$loading.show()
      axios._get(config.dashboardUri + config.statUri).then(response => {
        this.stats = response.data.dashboardStatistics
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get dashboard stats: ' + error)
          loader.hide()
        }
      })
    },
    async getExcelData () {
      let loader = this.$loading.show()
      axios._get(config.dashboardUri + config.excelStatUri).then(response => {
        this.excelJson = response.data
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get excel data: ' + error)
          loader.hide()
        }
      })
    },
    downloadExcel () {
      axios._get(config.dashboardUri + config.excelStatUri, {
        responseType: 'blob'
      }).then(response => {
        const filename = response.data.content.headers[2].Value[0].split('filename=')[1].split(';')[0]
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
    },
    getPercentage (input1, input2) {
      const percent = Math.round((100 * input1) / input2)
      return '(' + percent + '%)'
    },
    closeJumbo () {
      localStorage.setItem('jumbotron-closed-dashboard-cardio', true)
      this.closeJumbotron = true
    }
  },
  async beforeMount () {
    await this.getDashboardStats()
    await this.getExcelData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
h1 .sup {
  font-size: 0.3em;
  vertical-align: 15px;
}
.well {
  border: 1px solid lightgray;
  padding: 10px;
  width: 50%;
}
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 5px 15px 0px 0px;
  cursor: pointer;
  transform: scale(1.5);
}
.pointer {
  cursor: pointer;
}
.pull-left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardCardio.vue